import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Loader from './Loader';
import useAuth from '../hooks/useAuth';

import { ProtectedRouteProps } from '../types/components';

// ==============================|| PROTECTED ROUTE ||============================== //

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Mostrar loader mientras se verifica la autenticacion
  if (isLoading) {
    return <Loader />;
  }

  // Si no esta autenticado, redirigir al login
  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
      />
    );
  }

  // Si esta autenticado, mostrar el contenido protegido
  return children;
};

export default ProtectedRoute;

